// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import GaugeChartController from "./gauge_chart_controller"
application.register("gauge-chart", GaugeChartController)

import LineChartController from "./line_chart_controller"
application.register("line-chart", LineChartController)

import MapController from "./map_controller"
application.register("map", MapController)

import ProgressChartController from "./progress_chart_controller"
application.register("progress-chart", ProgressChartController)

import RadarChartController from "./radar_chart_controller"
application.register("radar-chart", RadarChartController)

import RangeDisplayController from "./range_display_controller"
application.register("range-display", RangeDisplayController)

import TomselectController from "./tomselect_controller"
application.register("tomselect", TomselectController)

import Notification from "stimulus-notification"
application.register("notification", Notification)
